"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultHttpCache = void 0;
const abstract_1 = require("./abstract");
const minute = 60000;
class DefaultHttpCache extends abstract_1.HttpCache {
    constructor() {
        super(...arguments);
        this._map = new Map();
        this._ttl = 10 * minute;
    }
    static get shared() {
        if (!DefaultHttpCache.sharedInstance) {
            DefaultHttpCache.sharedInstance = new DefaultHttpCache();
        }
        return DefaultHttpCache.sharedInstance;
    }
    get ttl() {
        return this._ttl;
    }
    set ttl(ttl) {
        if (typeof ttl === 'number' && ttl >= 0) {
            this._ttl = ttl;
        }
    }
    get size() {
        return this._map.size;
    }
    get(key) {
        const data = this._map.get(key);
        if (!data)
            return null;
        if (data.expires <= Date.now()) {
            this.delete(key);
            return null;
        }
        return data.data;
    }
    set(key, data) {
        this._map.set(key, {
            data,
            expires: Date.now() + this.ttl,
        });
        return this;
    }
    delete(key) {
        this._map.delete(key);
        return this;
    }
    reset() {
        this._map.clear();
        return this;
    }
}
exports.DefaultHttpCache = DefaultHttpCache;
